export enum FIELD_PRESETS {
  PARTNER_WITH_PARTNER_GROUPS = 'partner-with-partner-groups',
}
